// Used for file upload picker in fileUploader fn
const uploadTypes = '.pdf,.doc,.docx,.html,image/*';

export default uploadTypes;